function positionIvelloraFooterSocial() {
  const target = document.querySelector('[data-ivellora-footer-social-target]');
  const sourceSection = document.querySelector('.footer-utilities');
  const social = sourceSection?.querySelector('.social-icons__wrapper');

  if (!target) return;

  if (!social) {
    target.hidden = target.querySelectorAll('a[href]').length === 0;
    return;
  }

  target.querySelector('.social-icons__wrapper')?.remove();
  const socialClone = social.cloneNode(true);
  socialClone.removeAttribute('data-shopify-editor-block');
  socialClone.querySelectorAll('a[aria-label]').forEach((link) => {
    link.title = `Follow us on ${link.getAttribute('aria-label')}`;
  });
  target.appendChild(socialClone);
  target.hidden = socialClone.querySelectorAll('a[href]').length === 0;
  sourceSection.classList.add('ivellora-footer-social-source--moved');
  social.remove();
}

document.addEventListener('DOMContentLoaded', positionIvelloraFooterSocial);
document.addEventListener('shopify:section:load', () => requestAnimationFrame(positionIvelloraFooterSocial));
document.addEventListener('shopify:block:select', () => requestAnimationFrame(positionIvelloraFooterSocial));

const ivelloraFooterSocialObserver = new MutationObserver(() => {
  if (document.querySelector('.footer-utilities .social-icons__wrapper')) {
    positionIvelloraFooterSocial();
  }
});

ivelloraFooterSocialObserver.observe(document.documentElement, { childList: true, subtree: true });
